import { useReactTable, getCoreRowModel } from "@tanstack/react-table";

import ExportButtons from "./export/ExportButtons";
import Pagination from "./pagination/Pagination";
import GlobalSearch from "./globalSearch/GlobalSearch";
import MobileFilters from "./filters/MobileFilters";
import MobileSort from "./sort/MobileSort";
import TableHeader from "./table/TableHeader";
import TableBody from "./table/TableBody";
import ActionsColumn from "./actions/Actions";
import ResetFilterButton from "./resetFilterButton/ResetFilterButton";

export default function DataGrid({
  data = [],
  columns = [],
  pagination,
  onPaginationChange,
  sorting,
  onSortingChange,
  columnFilters,
  onColumnFiltersChange,
  pageCount,
  loading = false,
  hasGlobalSearch = false,
  searchGlobalPlaceholder = "Iskanje...",
  globalSearch = "",
  onGlobalSearchChange,
  hasActionColumn = false,
  hasExportCsvButton = false,
  onPodrobnostiActionClick,
  onDeleteActionClick,
  canDelete,
  onPovezavaActionClick,
  exportFileMutation,
}) {
  const table = useReactTable({
    data,
    columns,
    state: {
      pagination,
      sorting,
      columnFilters,
    },
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
    pageCount,
    onPaginationChange,
    onSortingChange,
    onColumnFiltersChange,
    getCoreRowModel: getCoreRowModel(),
  });

  //Add Action column if hasActionColumn is true and it doesn't already exist
  if (hasActionColumn && !columns.some((c) => c.id === "actions")) {
    ActionsColumn({
      columns,
      onPodrobnostiActionClick,
      onDeleteActionClick,
      canDelete,
      onPovezavaActionClick,
    });
  }

  return (
    <div className="my-5">
      <div className="responsive-globalsearch-export d-flex align-items-center justify-content-between gap-3 mb-3">
        {/* GLOBAL SEARCH */}
        {hasGlobalSearch && (
          <GlobalSearch
            searchGlobalPlaceholder={searchGlobalPlaceholder}
            globalSearch={globalSearch}
            onGlobalSearchChange={onGlobalSearchChange}
          />
        )}

        <div className="d-flex align-items-center gap-2 ms-auto">
          <ResetFilterButton
            table={table}
            onReset={() => {
              if (onGlobalSearchChange) onGlobalSearchChange("");
            }}
          />
          {/* EXPORT CSV BUTTON */}
          {hasExportCsvButton && (
            <ExportButtons exportFileMutation={exportFileMutation} />
          )}
        </div>
      </div>

      <div className="card-body">
        <div className="responsive-mobile-filters-sort">
          {/* MOBILE FILTERS */}
          <div className="center-align-mobile d-flex align-items-center flex-wrap gap-2 mb-3">
            <MobileFilters table={table} />
          </div>

          {/* MOBILE SORT */}
          <div className="center-align-mobile d-flex align-items-center flex-wrap gap-2">
            <MobileSort table={table} />
          </div>
        </div>

        {/* DATAGRID which is Responsive with Mobile Support */}
        <div className="card-body" style={{ overflow: "visible" }}>
          <div
            className="table-responsive"
            style={{ minHeight: "400px", overflow: "visible" }}
          >
            <table
              className="responsive-table "
              style={{
                width: "100%",
                borderCollapse: "collapse",
                background: "white",
                fontSize: "14px",
              }}
            >
              {/* TABLE HEADER */}
              <TableHeader table={table} />
              {/* TABLE BODY */}
              <TableBody table={table} columns={columns} loading={loading} />
            </table>
          </div>

          {/* PAGINATION */}
          {<Pagination table={table} />}
        </div>
      </div>
    </div>
  );
}
